<!-- 招商推介主页面 -->
<template>
  <div class="biddinghall_w bc_F2F2F2">
    <div class="content_w">
      <div class="site_content">
        <div class="top_w">
          <div class=" d_flex align_item_c">

            <SiteBreadcrumb />

            <div
              style="margin-left:10px"
              class="dynamic_tabs_w d_flex "
              v-for="item in dynamicTabs"
              :key="item.tabType"
            >
              <div class="d_tab_i bc_fff fz12 c_1A1A1A">
                <span class="span_1">{{ item.value }}</span>
                <i
                  @click="setDynamicTabsVal(item.tabType)"
                  class="icon_i el-icon-close"
                ></i>
              </div>
            </div>

            <div class="div_3 d_flex justify_content_sb align_item_c">
              <span class="fz12 c_1A1A1A"
                >（共{{ merchantDataRes.total }}条招商信息）</span
              >
              <span
                class="span_2 fz12 c_1A1A1A bc_fff cursor_pointer"
                @click="clearScreen"
                >清空筛选项</span
              >
            </div>
          </div>
        </div>

        <div class="div_1 bc_fff" style="margin-bottom: 11px;">
          <div class="solid_line" />
          <!-- 所在区域 -->
          <SwitchTabs
            :tabs="siteInfo.subsetRegions"
            value-key="key"
            label-key="value"
            desc="所在区域:"
            @change="onAreaChange"
            v-model="screenForm.locId"
            class="div_2 align_item_fs"
          />
          <div class="solid_line" />
          <SwitchTabs
            :tabs="transferModes"
            value-key="key"
            label-key="value"
            desc="转出方式:"
            @change="onTransferModeChange"
            v-model="screenForm.transferMode"
          />
        </div>

        <!-- <div class="other_screen_w bc_fff d_flex">
          <div
            class="screen_i"
            :class="screenForm.sort === 0 ? 'active_sort' : ''"
            @click="onDefaultClick(0)"
          >
            默认
          </div>
          <div
            class="screen_i sort_price"
            :class="
              screenForm.sort === 1 || screenForm.sort === 2
                ? 'active_sort'
                : ''
            "
            @click="onSortPrice"
          >
            价格
          </div>
          <div
            class="screen_i"
            :class="screenForm.sort === 3 ? 'active_sort' : ''"
            @click="onDefaultClick(3)"
          >
            最新发布
          </div>
        </div> -->

        <!-- 招商信息列表 -->
        <MerchantList  :list="merchantDataRes.list" >
          <template #inner>
            <MerchantItem
              v-for="item in merchantDataRes.list"
              :key="item.id"
              :data="item"
              @click.native="onGoMerchantItem(item.id)"
            />
          </template>
        </MerchantList>

        <div class="padding_1 d_flex justify_content_c">
          <!--分页-->
          <MyPagination
            :current-page="merchantDataRes.pageNum"
            :total="merchantDataRes.total"
            style="margin-top: 8px"
            change-method-name="getMerchantList"
            :that="this"
            layout="total,sizes, prev, pager, next, jumper"
            :pageInfo="pageInfo"
            :pageSizes="[16]"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SwitchTabs from "@/components/base/SwitchTabs.vue";
import { mapGetters } from "vuex";
import { portal_merchant_List } from "@/api/portal";
import MyPagination from "@/components/base/MyPagination.vue";
import { isEmtry } from "@/utils";

import SiteBreadcrumb from '@/components/base/SiteBreadcrumb.vue'
import MerchantItem from "@/components/template/otherTradeKind/MerchantItem.vue";
import MerchantList from '@/components/template/MerchantList.vue'

export default {
  components: {
    SwitchTabs,
    MerchantItem,
    MyPagination,
    SiteBreadcrumb,
    MerchantList,
  },
  metaInfo() {
    return {
      title: `${this.$route.meta?.title} ${this.siteInfo?.name ? ' - '+this.siteInfo?.name:''}`,
    }
  },
  data() {
    return {
      //
      pageInfo: {
        page: 1,
        rows: 16,
      },
      merchantDataRes: {},
      screenForm: {
        locId: null,
        transferMode: null,
      }, // 筛选表单

      dynamicTabs: [], //动态tabs项
      biddingType: "",
      requestUrl: "",
    };
  },
  computed: {
    ...mapGetters(["siteInfo",'transferModes']),
  },
  watch: {
    "screenForm.locId": function (n) {
      this.screenForm.locId = n === '' ? '' : n;
      this.getMerchantList()
    },
    "screenForm.transferMode": function (n) {
      this.screenForm.transferMode = n === '' ? '' : n;
      this.getMerchantList()
    },
  },
  created() {
    // 三：1.对接招商大厅数据
    this.getMerchantList();
  },
  methods: {
    // 获取招商信息列表 api
    async getMerchantList() {
      const { data } = await portal_merchant_List(
        {
          ...this.screenForm,
          ...this.pageInfo
        }
      );
      if (!data.list) {
        this.merchantDataRes = {
          list: [],
          pageNum: 0,
          pageSize: 0,
          total: 0,
        };
        return;
      }
      this.merchantDataRes = data;
    },

    //前往招商详情页 click
    onGoMerchantItem(id) {
      this.$router.push({
        name:'merchantDetail',
        query:{
          id
        }
      });
    },

    // 地区 change
    onAreaChange(tab) {
      this.setDynamicTabs(tab,'locId')
    },
    // 转出方式 change
    onTransferModeChange(tab) {
      this.setDynamicTabs(tab,'transferMode')
    },
    //设置动态tabs
    setDynamicTabs(tab,tabType) {
      this.pageInfo.page = 1;
      this.dynamicTabs = this.dynamicTabs.filter(item=>item.tabType !== tabType)
      if(isEmtry(tab)) return
      tab.tabType = tabType
      this.dynamicTabs.push(tab);
    },

    // 设置动态tabs项value
    setDynamicTabsVal(tabType) {
      this.screenForm[tabType] = null;
      this.setDynamicTabs(null,tabType)
      this.getMerchantList();
    },
    //清空筛选项 click
    clearScreen() {
      this.screenForm.transferMode = null;
      this.screenForm.locId = null;
      this.dynamicTabs = []
      this.getMerchantList();
    },
  },
};
</script>

<style lang="scss" scoped>
.biddinghall_w {
  .empty_w {
    min-height: 200px;
    margin: 50px auto;
  }
  .dynamic_tabs_w {
    margin: 0 10px 0 0;
    .d_tab_i {
      border: 1px solid #e6e6e6;
      margin: 0 10px 0 0;
      padding: 5px 10px;
      &:last-child {
        margin: 0;
      }
      &:hover {
        cursor: pointer;
        color: #0983cc;
      }
      .icon_i {
        border-radius: 50%;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        &:hover {
          background-color: #c0c4cc;
          color: #fff;
        }
      }
    }
  }
  .div_1 {
    border: 1px solid #e6e6e6;
  }
  ::v-deep .div_2 {
    padding: 17px 10px 0 10px;
    .desc_w {
      margin: 0;
    }
    .tabs_w {
      padding: 0;

      .active_tab {
        margin: 0 0 17px 0;
      }
      .tab_i {
        margin: 0 0 17px 0;
      }
    }
  }
  .div_3 {
    flex: 1;
  }
  .other_screen_w {
    padding: 10px;
    margin: 10px 0;
    border: 1px solid #e6e6e6;
    .screen_i {
      padding: 10px 28px;
      font-size: 12px;

      color: #1a1a1a;
      border: 1px solid #e6e6e6;
      &:nth-child(even) {
        border-right: 0;
        border-left: 0;
      }
      &:hover {
        cursor: pointer;
        background-color: rgba($color: #e6e6e6, $alpha: 0.5);
      }
    }
    .sort_price {
      position: relative;
      &::before {
        content: "";
        position: absolute;
        width: 10px;
        height: 5px;
        top: 11px;
        right: 12px;
        background: url("~@/assets/images/up_arrow.png") 100% 100% / cover
          no-repeat;
      }
      &::after {
        content: "";
        position: absolute;
        bottom: 11px;
        right: 12px;
        width: 10px;
        height: 5px;
        background: url("~@/assets/images/down_arrow.png") 100% 100% / cover
          no-repeat;
      }
    }
  }

  .active_sort {
    background-color: rgba($color: #e6e6e6, $alpha: 0.5);
  }

  ::v-deep .el-pagination__sizes {
    display: none !important;
  }
  ::v-deep .el-breadcrumb {
    display: flex;
  }
  ::v-deep .el-breadcrumb__item,
  ::v-deep .el-breadcrumb__inner {
    display: flex;
    align-items: center;
  }
  .margin_1 {
    //null
    // margin: 0 0 0 50px;
  }
  .margin_2 {
    margin: 0 8px;
  }
  .margin_3 {
    margin: 0 14px 0 0;
  }
  .margin_4 {
    margin: 0 0 0 10px;
  }
  .margin_5 {
    margin: 0 0 0 24px;
  }
  .margin_6 {
    margin: 0 20px 0 0;
  }
  .padding_1 {
    padding: 21px 0;
  }
  .span_1 {
    margin: 0 20px 0 0;
  }
  .span_2 {
    padding: 6px 20px;
  }
  .project_w {
    display: flex;
    flex-wrap: wrap;
  }
  .content_w {
    padding-top: 20px;
  }

  .screen_w {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    padding: 11px 21px;
    margin: 35px 0 0 0;
    .count_nav {
      // float: left;
    }
    .price_w {
      // float: left;
    }
    .sort_w {
      display: flex;
      align-items: center;
    }
  }
}
</style>
